// Header.vue toggles this on scroll direction. It's a global singleton (rather than
// Header.vue's provide/inject) so components outside Header's own subtree - e.g. the
// news sidebar, which is a layout sibling of GlobalHeader, not a descendant - can still
// read it to keep their sticky offsets in sync with the header/topbar height.
export const useIsTopBarVisible = createGlobalState(() => ref(true))
